const ArrowDown = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    aria-labelledby="title"
    aria-describedby="desc"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer1"
      fill={color}
      d="M16 36l16 16 16-16-4.242-4.243-8.759 8.759V12h-6v28.514l-8.757-8.757L16 36z"
    ></path>
  </svg>
);

export default ArrowDown;
